module.exports = __webpack_public_path__ + "img/rank1.91584813.png";